"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.zip = void 0;

var _Observable = require("./Observable");

var zip = function zip(left) {
  return function (right) {
    return (0, _Observable.mkObservable)(function (observer) {
      var left_queue = [];
      var right_queue = [];
      var leftObserver = {
        next: function next(x) {
          left_queue.push(x);
          var r = right_queue.shift();

          if (typeof r !== "undefined") {
            var l = left_queue.shift();
            observer.next([l, r]);
          }
        },
        error: function error(err) {
          return observer.error(err);
        },
        complete: function complete() {
          return observer.complete();
        }
      };
      var rightObserver = {
        next: function next(x) {
          right_queue.push(x);
          var l = left_queue.shift();

          if (typeof l !== "undefined") {
            var r = right_queue.shift();
            observer.next([l, r]);
          }
        },
        error: function error(err) {
          return observer.error(err);
        },
        complete: function complete() {
          return observer.complete();
        }
      };
      var left_unsub = left.subscribe(leftObserver);
      var right_unsub = right.subscribe(rightObserver);

      var unsub = function unsub() {
        left_unsub();
        right_unsub();
      };

      return unsub;
    });
  };
};

exports.zip = zip;